<script setup lang="ts">
/** Numeric answer: one string the kid types on the keypad. Equal values grade (`7/10` for `0.7`). */
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { MathExerciseEditorProps } from '../../../../../model/assignments/math-exercise-editors.hook'

import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'

import {
  KEYPAD_HINT,
  useMathExerciseNumeric,
} from '../../../../../model/assignments/math-exercise-editors.hook'

defineOptions({
  name: 'ExerciseNumeric',
})

const props = defineProps<MathExerciseEditorProps>()

const {
  refAnswer,
  refIsUntypeable,
  setAnswer,
} = useMathExerciseNumeric(() => props.exercise)
</script>

<template>
  <div class="exercise-numeric">
    <InputPrimary
      name="answer"
      label="Answer"
      :value="refAnswer"
      :mode="refIsUntypeable ? 'error' : 'normal'"
      placeholder="e.g. 42, -3, 0.5 or 2/3"
      @input="(event: InputPrimaryEvent) => setAnswer(String(event.value))"
    />
    <AppText
      name="body2"
      :color="refIsUntypeable ? 'red-600' : 'slate-500'"
    >
      {{ KEYPAD_HINT }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./ExerciseNumeric.scss" />
